import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  es: {
    // Navbar
    nav: {
      services: 'Servicios',
      about: 'Nosotros',
      contact: 'Contacto',
      cta: 'Iniciar Proyecto',
    },
    // Hero
    hero: {
      badge: 'Software • IA • Digitalización',
      title1: 'Impulsando tu',
      title2: 'Futuro Digital',
      subtitle: 'Desarrollamos software a medida, implementamos inteligencia artificial y digitalizamos procesos para impulsar tu negocio hacia el mañana.',
      ctaPrimary: 'Iniciar Proyecto',
      ctaSecondary: 'Ver Servicios',
      stat1: 'Proyectos',
      stat2: 'Satisfacción',
      stat3: 'Soporte',
    },
    // Services
    services: {
      label: 'Nuestros Servicios',
      title1: 'Soluciones que',
      title2: 'Transforman',
      items: [
        {
          title: 'Desarrollo de Software',
          description: 'Arquitecturas personalizadas construidas para escalar. Desde aplicaciones web hasta sistemas empresariales complejos.',
          features: ['Aplicaciones Web', 'APIs & Microservicios', 'Sistemas a Medida'],
        },
        {
          title: 'Implementación de IA',
          description: 'Redes neuronales que impulsan la lógica de negocio. Automatización inteligente para decisiones más rápidas.',
          features: ['Machine Learning', 'Procesamiento de Datos', 'Chatbots & Asistentes'],
        },
        {
          title: 'Digitalización',
          description: 'Transformamos lo legacy en definidor de legados. Modernización de procesos para la era digital.',
          features: ['Automatización', 'Migración Cloud', 'Optimización'],
        },
        {
          title: 'Consultoría Tech',
          description: 'Estrategia tecnológica que impulsa resultados. Te guiamos en cada paso de tu transformación digital.',
          features: ['Arquitectura', 'Roadmaps', 'Best Practices'],
        },
        {
          title: 'Project Management',
          description: 'Gestión ágil de proyectos tecnológicos. Entregamos a tiempo, en presupuesto y con la máxima calidad.',
          features: ['Metodologías Ágiles', 'Scrum & Kanban', 'Delivery Continuo'],
        },
        {
          title: 'Ciberseguridad',
          description: 'Protegemos tu infraestructura digital. Auditorías, pentesting y soluciones de seguridad robustas.',
          features: ['Auditorías', 'Pentesting', 'Compliance'],
        },
      ],
      cta: 'Contactar ahora',
      notFound: '¿No encuentras lo que buscas? Hablemos de tu proyecto único.',
    },
    // About
    about: {
      label: 'Sobre Nosotros',
      title1: 'Somos',
      title2: 'AJ Code Labs',
      p1: 'Somos un equipo apasionado de desarrolladores, ingenieros de IA y consultores digitales comprometidos con la excelencia tecnológica.',
      p2: 'Fundada con la visión de democratizar la tecnología avanzada, AJ Code Labs transforma ideas ambiciosas en soluciones de software que impulsan el crecimiento empresarial.',
      p3: 'Desde startups hasta empresas establecidas, ayudamos a nuestros clientes a navegar la transformación digital con confianza y resultados medibles.',
      stat1: 'Años de Experiencia',
      stat2: 'Clientes Satisfechos',
      stat3: 'Innovación Constante',
      values: [
        { title: 'Precisión', description: 'Cada línea de código cuenta. Desarrollamos con exactitud y propósito.' },
        { title: 'Colaboración', description: 'Tu visión, nuestra experiencia. Trabajamos juntos hacia el éxito.' },
        { title: 'Innovación', description: 'Siempre un paso adelante. Adoptamos las últimas tecnologías.' },
        { title: 'Confianza', description: 'Seguridad y transparencia en cada proyecto que emprendemos.' },
      ],
      techLabel: 'Tecnologías que dominamos',
    },
    // Logo showcase
    logos: {
      label: 'Propuestas de Logo',
      title1: 'Tu',
      title2: 'Identidad',
      title3: 'Visual',
      subtitle: 'Diseños que reflejan innovación, tecnología y profesionalismo',
      usage: 'Ejemplo de Uso',
      options: [
        { name: 'Geométrico', desc: 'Moderno y abstracto' },
        { name: 'Code Brackets', desc: 'Estilo desarrollador' },
        { name: 'Circuito', desc: 'Tech & conectividad' },
        { name: 'Hexágono', desc: 'Estructura & estabilidad' },
      ],
    },
    // Contact
    contact: {
      label: 'Contacto',
      title1: 'Iniciemos tu',
      title2: 'Proyecto',
      subtitle: '¿Tienes una idea o proyecto en mente? Cuéntanos y hagamos realidad tu visión tecnológica.',
      globalPresence: 'Presencia Global',
      offices: [
        { city: 'Miami', country: 'Florida, USA' },
        { city: 'Quito', country: 'Ecuador' },
        { city: 'Londres', country: 'United Kingdom' },
      ],
      form: {
        name: 'nombre',
        email: 'email',
        phone: 'teléfono / whatsapp',
        phonePlaceholder: '+1 (555) 123-4567',
        company: 'empresa',
        companyOptional: '(opcional)',
        projectType: 'tipo_proyecto',
        urgency: '¿qué tan urgente es?',
        urgencyPlaceholder: 'Selecciona la urgencia',
        message: 'mensaje',
        namePlaceholder: 'Tu nombre',
        emailPlaceholder: 'tu@email.com',
        companyPlaceholder: 'Tu empresa',
        projectPlaceholder: 'Selecciona una opción',
        messagePlaceholder: 'Cuéntanos sobre tu proyecto...',
        submit: 'Enviar Mensaje',
        sending: 'Enviando...',
        sent: '¡Enviado!',
      },
      projectTypes: [
        'Desarrollo de Software',
        'Implementación de IA',
        'Digitalización de Procesos',
        'Consultoría Tecnológica',
        'Project Management',
        'Ciberseguridad',
        'Otro',
      ],
      emailLabel: 'Email',
      hqLabel: 'Sede Principal',
      hqExtra: '+ Quito & Londres',
      available: 'Disponible para proyectos',
      availableDesc: 'Actualmente aceptamos nuevos proyectos. Tiempo de respuesta: menos de 24 horas.',
      successTitle: '¡Mensaje enviado correctamente!',
      successDesc: 'Nos pondremos en contacto contigo pronto.',
      errorTitle: 'Error al enviar el mensaje',
      errorDesc: 'Por favor, inténtalo de nuevo.',
    },
    // Footer
    footer: {
      rights: 'Todos los derechos reservados.',
      tagline: 'Diseñado y desarrollado con',
      passion: 'pasión',
      taglineEnd: 'por la tecnología',
      startProject: 'Iniciar un proyecto',
      privacy: 'Privacidad',
      terms: 'Términos',
      smsConsent: 'Consentimiento SMS',
    },
  },
  en: {
    // Navbar
    nav: {
      services: 'Services',
      about: 'About',
      contact: 'Contact',
      cta: 'Start Project',
    },
    // Hero
    hero: {
      badge: 'Software • AI • Digitalization',
      title1: 'Driving your',
      title2: 'Digital Future',
      subtitle: 'We develop custom software, implement artificial intelligence, and digitize processes to propel your business into tomorrow.',
      ctaPrimary: 'Start Project',
      ctaSecondary: 'View Services',
      stat1: 'Projects',
      stat2: 'Satisfaction',
      stat3: 'Support',
    },
    // Services
    services: {
      label: 'Our Services',
      title1: 'Solutions that',
      title2: 'Transform',
      items: [
        {
          title: 'Software Development',
          description: 'Custom architectures built to scale. From web applications to complex enterprise systems.',
          features: ['Web Applications', 'APIs & Microservices', 'Custom Systems'],
        },
        {
          title: 'AI Implementation',
          description: 'Neural networks that drive business logic. Intelligent automation for faster decisions.',
          features: ['Machine Learning', 'Data Processing', 'Chatbots & Assistants'],
        },
        {
          title: 'Digitalization',
          description: 'Transforming legacy into legacy-defining. Process modernization for the digital age.',
          features: ['Automation', 'Cloud Migration', 'Optimization'],
        },
        {
          title: 'Tech Consulting',
          description: 'Technology strategy that drives results. We guide you through every step of your digital transformation.',
          features: ['Architecture', 'Roadmaps', 'Best Practices'],
        },
        {
          title: 'Project Management',
          description: 'Agile management of technology projects. We deliver on time, on budget, with maximum quality.',
          features: ['Agile Methods', 'Scrum & Kanban', 'Continuous Delivery'],
        },
        {
          title: 'Cybersecurity',
          description: 'We protect your digital infrastructure. Audits, pentesting, and robust security solutions.',
          features: ['Audits', 'Pentesting', 'Compliance'],
        },
      ],
      cta: 'Contact now',
      notFound: "Can't find what you're looking for? Let's talk about your unique project.",
    },
    // About
    about: {
      label: 'About Us',
      title1: "We are",
      title2: 'AJ Code Labs',
      p1: 'We are a passionate team of developers, AI engineers, and digital consultants committed to technological excellence.',
      p2: 'Founded with the vision of democratizing advanced technology, AJ Code Labs transforms ambitious ideas into software solutions that drive business growth.',
      p3: 'From startups to established companies, we help our clients navigate digital transformation with confidence and measurable results.',
      stat1: 'Years of Experience',
      stat2: 'Satisfied Clients',
      stat3: 'Constant Innovation',
      values: [
        { title: 'Precision', description: 'Every line of code counts. We develop with accuracy and purpose.' },
        { title: 'Collaboration', description: 'Your vision, our expertise. We work together towards success.' },
        { title: 'Innovation', description: 'Always one step ahead. We adopt the latest technologies.' },
        { title: 'Trust', description: 'Security and transparency in every project we undertake.' },
      ],
      techLabel: 'Technologies we master',
    },
    // Logo showcase
    logos: {
      label: 'Logo Proposals',
      title1: 'Your',
      title2: 'Visual',
      title3: 'Identity',
      subtitle: 'Designs that reflect innovation, technology, and professionalism',
      usage: 'Usage Example',
      options: [
        { name: 'Geometric', desc: 'Modern and abstract' },
        { name: 'Code Brackets', desc: 'Developer style' },
        { name: 'Circuit', desc: 'Tech & connectivity' },
        { name: 'Hexagon', desc: 'Structure & stability' },
      ],
    },
    // Contact
    contact: {
      label: 'Contact',
      title1: "Let's start your",
      title2: 'Project',
      subtitle: 'Have an idea or project in mind? Tell us and let\'s make your technological vision a reality.',
      globalPresence: 'Global Presence',
      offices: [
        { city: 'Miami', country: 'Florida, USA' },
        { city: 'Quito', country: 'Ecuador' },
        { city: 'London', country: 'United Kingdom' },
      ],
      form: {
        name: 'name',
        email: 'email',
        phone: 'phone / whatsapp',
        phonePlaceholder: '+1 (555) 123-4567',
        company: 'company',
        companyOptional: '(optional)',
        projectType: 'project_type',
        urgency: 'how urgent is it?',
        urgencyPlaceholder: 'Select urgency',
        message: 'message',
        namePlaceholder: 'Your name',
        emailPlaceholder: 'you@email.com',
        companyPlaceholder: 'Your company',
        projectPlaceholder: 'Select an option',
        messagePlaceholder: 'Tell us about your project...',
        submit: 'Send Message',
        sending: 'Sending...',
        sent: 'Sent!',
      },
      projectTypes: [
        'Software Development',
        'AI Implementation',
        'Process Digitalization',
        'Tech Consulting',
        'Project Management',
        'Cybersecurity',
        'Other',
      ],
      emailLabel: 'Email',
      hqLabel: 'Headquarters',
      hqExtra: '+ Quito & London',
      available: 'Available for projects',
      availableDesc: 'Currently accepting new projects. Response time: less than 24 hours.',
      successTitle: 'Message sent successfully!',
      successDesc: 'We will get in touch with you soon.',
      errorTitle: 'Error sending message',
      errorDesc: 'Please try again.',
    },
    // Footer
    footer: {
      rights: 'All rights reserved.',
      tagline: 'Designed and developed with',
      passion: 'passion',
      taglineEnd: 'for technology',
      startProject: 'Start a project',
      privacy: 'Privacy',
      terms: 'Terms',
      smsConsent: 'SMS Consent',
    },
  },
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('aj-language');
    return saved || 'es';
  });

  useEffect(() => {
    localStorage.setItem('aj-language', language);
  }, [language]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'es' ? 'en' : 'es'));
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
